import { useLoginContext } from 'stagedive/LoginContext'
import { toNullable } from 'fp-ts/es6/Option'
import React from 'react'

export const AdsConsoleHub: React.FunctionComponent = (): JSX.Element => {
  const { loginContext } = useLoginContext()
  const partnerId = toNullable(loginContext.partnerProfileId) ?? ''
  window.location.replace(`/am/managerAccounts/${partnerId}/accounts?entityId=${partnerId}`)
  return <React.Fragment />
}
